import { CONTACTS_ACTIONS } from 'store/v1/contacts/contacts.constants.js';
import { BOOKING_ACTIONS } from 'store/v1/bookings/bookings.constants.js';
import { SHORTLISTS_ACTIONS } from 'store/v1/shortlists/shortlists.constants.js';
import { PRODUCTIONS_ACTIONS } from 'store/v1/productions/productions.constants.js';
import { SYSTEM_ACTIONS } from 'store/v1/system/system.constants.js';
import {
  cloneDeep,
  findIndex,
  get,
  find,
  keys,
  filter,
  isEmpty,
  omit,
  setWith
} from 'lodash';

// TODO: This contacts store needs a huge clean.

export const INITIAL_STATE = {
  associations_data: {},
  events_data: {},
  new: {},
  socials_data: {},
  loading: false
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CONTACTS_ACTIONS.GET_CONTACT_ASSOCIATIONS:
    case CONTACTS_ACTIONS.GET_CONTACT_PINS:
    case CONTACTS_ACTIONS.GET_CONTACT_EVENTS:
    case CONTACTS_ACTIONS.GET_GROUPS:
    case CONTACTS_ACTIONS.CREATE_CONTACT:
    case CONTACTS_ACTIONS.CREATE_CONTACT_NOTE:
    case CONTACTS_ACTIONS.CREATE_CONTACT_DOCUMENT:
    case CONTACTS_ACTIONS.CREATE_CONTACT_AVAILABILITY:
    case CONTACTS_ACTIONS.CREATE_CONTACT_PIN:
    case CONTACTS_ACTIONS.UPDATE_CONTACT_PIN:
    case CONTACTS_ACTIONS.UPDATE_CONTACT_PINS:
    case CONTACTS_ACTIONS.CREATE_BULK_CONTACTS:
    case CONTACTS_ACTIONS.CREATE_GROUP:
    case CONTACTS_ACTIONS.UPDATE_CONTACT:
    case CONTACTS_ACTIONS.UPDATE_GDPR_BASIS:
    case CONTACTS_ACTIONS.UPDATE_GDPR_REQUESTED_DATES:
    case CONTACTS_ACTIONS.ARCHIVE_CONTACT:
    case CONTACTS_ACTIONS.ARCHIVE_CONTACT_BATCH:
    case CONTACTS_ACTIONS.UNARCHIVE_CONTACT:
    case CONTACTS_ACTIONS.DELETE_GDPR_CONTACT:
    case CONTACTS_ACTIONS.DELETE_CONTACT_NOTE:
    case CONTACTS_ACTIONS.DELETE_CONTACT_DOCUMENT:
    case CONTACTS_ACTIONS.DELETE_CONTACT_AVAILABILITY:
    case CONTACTS_ACTIONS.DELETE_CONTACT_PIN:
    case CONTACTS_ACTIONS.DOWNLOAD_GDPR_DATA:
    case CONTACTS_ACTIONS.GET_BATCH_CONTACTS_EVENTS:
    case CONTACTS_ACTIONS.BATCH_GET_AVAILABILITY:
      return {
        ...state,
        loading: action.type,
        error: false
      };
    case CONTACTS_ACTIONS.BATCH_GET_AVAILABILITY_SUCCESS:
      return {
        ...state,
        associations_data: state.associations_data
      };

    case CONTACTS_ACTIONS.GET_CONTACT_ASSOCIATIONS_SUCCESS:
      return {
        ...state,
        associations_data: {
          ...state.associations_data,
          [action.contact_id]: action.result
        },
        loading: false
      };
    case SHORTLISTS_ACTIONS.DELETE_SHORTLIST_BLOCK_SUCCESS: {
      let shortlist_blocks = get(state, [
        'associations_data',
        action.contact_id,
        'shortlist_blocks'
      ]);
      let updatedShortlistBlocks = filter(
        shortlist_blocks,
        b => b.id != action.shortlist_block_id
      );
      return {
        ...state,
        associations_data: {
          ...state.associations_data,
          [action.contact_id]: {
            ...state.associations_data[action.contact_id],
            shortlist_blocks: updatedShortlistBlocks
          }
        }
      };
    }
    case SHORTLISTS_ACTIONS.CREATE_SHORTLIST_BLOCK_SUCCESS: {
      if (!isEmpty(state.associations_data[action.result.contact_id])) {
        return {
          ...state,
          associations_data: {
            ...state.associations_data,
            [action.result.contact_id]: {
              ...state.associations_data[action.result.contact_id],
              shortlist_blocks: [
                { ...action.result, shortlist: action.shortlist },
                ...state.associations_data[action.result.contact_id]
                  .shortlist_blocks
              ]
            }
          }
        };
      }
      return state;
    }
    case CONTACTS_ACTIONS.GET_CONTACT_PINS_SUCCESS:
    case CONTACTS_ACTIONS.CREATE_CONTACT_NOTE_SUCCESS:
    case CONTACTS_ACTIONS.CREATE_CONTACT_PIN_SUCCESS:
    case CONTACTS_ACTIONS.CREATE_CONTACT_DOCUMENT_SUCCESS:
    case CONTACTS_ACTIONS.CREATE_CONTACT_AVAILABILITY_SUCCESS: {
      const selector = {
        CREATE_CONTACT_NOTE_SUCCESS: 'notes',
        CREATE_CONTACT_PIN_SUCCESS: 'pins',
        CREATE_CONTACT_DOCUMENT_SUCCESS: 'documents',
        CREATE_CONTACT_AVAILABILITY_SUCCESS: 'availability_requests'
      }[action.type];

      const list = [
        action.result,
        ...state.associations_data[action.contact_id][selector]
      ];

      return {
        ...state,
        loading: false,
        associations_data: setWith(
          cloneDeep(state.associations_data),
          `${action.contact_id}.${selector}`,
          list,
          cloneDeep
        )
      };
    }
    case CONTACTS_ACTIONS.GET_CONTACT_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        events_data: {
          ...state.events_data,
          [action.contact_id]: action.result.events.filter(e => !e.archived)
        }
      };
    case CONTACTS_ACTIONS.UPDATE_CONTACT_PINS_SUCCESS:
      const existingPins = get(state.associations_data, [
        action.contact_id,
        'pins'
      ]);
      const updatedPins = action.result.map(pin => {
        const resultPin = find(existingPins, p => p.id === pin.id);
        return { ...resultPin, order: pin.order };
      });
      return {
        ...state,
        loading: false,
        associations_data: setWith(
          cloneDeep(state.associations_data),
          `${action.contact_id}.pins`,
          updatedPins,
          cloneDeep
        )
      };
    case CONTACTS_ACTIONS.REORDER_CONTACT_DOCUMENTS_SUCCESS: {
      const documents = get(state.associations_data, [
        action.contact_id,
        'documents'
      ]);
      return {
        ...state,
        associations_data: setWith(
          cloneDeep(state.associations_data),
          `${action.contact_id}.documents`,
          documents.map(doc => ({
            ...doc,
            order:
              find(action.result, row => row.id === doc.id)?.order ?? doc.order
          })),
          cloneDeep
        )
      };
    }
    case CONTACTS_ACTIONS.UPDATE_CONTACT_PIN_SUCCESS:
      let pins = state.associations_data[action.contact_id].pins ?? [];
      const pinIndex = findIndex(pins, p => p.id === action.pin_id);

      pins[pinIndex] = action.result;
      return {
        ...state,
        loading: false,
        associations_data: setWith(
          cloneDeep(state.associations_data),
          `${action.contact_id}.pins`,
          pins,
          cloneDeep
        )
      };
    case CONTACTS_ACTIONS.DELETE_CONTACT_NOTE_SUCCESS:
    case CONTACTS_ACTIONS.DELETE_CONTACT_PIN_SUCCESS:
    case CONTACTS_ACTIONS.DELETE_CONTACT_DOCUMENT_SUCCESS:
    case CONTACTS_ACTIONS.DELETE_CONTACT_AVAILABILITY_SUCCESS: {
      const selector = {
        DELETE_CONTACT_NOTE_SUCCESS: 'notes',
        DELETE_CONTACT_PIN_SUCCESS: 'pins',
        DELETE_CONTACT_DOCUMENT_SUCCESS: 'documents',
        DELETE_CONTACT_AVAILABILITY_SUCCESS: 'availability_requests'
      }[action.type];

      const list = state.associations_data[action.contact_id][selector].filter(
        n => n.id !== action.association_id
      );

      return {
        ...state,
        loading: false,
        associations_data: setWith(
          cloneDeep(state.associations_data),
          `${action.contact_id}.${selector}`,
          list,
          cloneDeep
        ),
        error: false
      };
    }

    case CONTACTS_ACTIONS.CREATE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        new: action.result,
        error: false
      };
    case CONTACTS_ACTIONS.UPDATE_CONTACT_SUCCESS:
    case CONTACTS_ACTIONS.ARCHIVE_CONTACT_SUCCESS:
    case CONTACTS_ACTIONS.ARCHIVE_CONTACT_BATCH_SUCCESS:
    case CONTACTS_ACTIONS.UNARCHIVE_CONTACT_SUCCESS:
    case CONTACTS_ACTIONS.UPDATE_GDPR_BASIS_SUCCESS:
    case CONTACTS_ACTIONS.UPDATE_GDPR_REQUESTED_DATES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false
      };

    // The merged-away contact is deleted and the kept one inherits its notes, documents and
    // pins: both are read again when a page asks for them.
    case SYSTEM_ACTIONS.MERGE_RESOURCE_SUCCESS:
      return {
        ...state,
        associations_data: omit(state.associations_data, [
          action.from_id,
          action.to_id
        ])
      };

    case CONTACTS_ACTIONS.GET_SOCIAL_DATA:
      return {
        ...state,
        socials_data: {
          ...state.socials_data,
          [`${action.provider}.${action.handle}`]: {
            loading: true
          }
        }
      };
    case CONTACTS_ACTIONS.GET_SOCIAL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        socials_data: {
          ...state.socials_data,
          [`${action.provider}.${action.handle}`]: {
            ...action.result.data,
            provider: action.provider
          }
        }
      };
    case CONTACTS_ACTIONS.GET_SOCIAL_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        socials_data: {
          ...state.socials_data,
          [`${action.provider}.${action.handle}`]: {
            error: action.error
          }
        }
      };

    case CONTACTS_ACTIONS.SET_ONBOARD_DATA:
      return {
        ...state,
        onboard_csv_data: action.data,
        onboard_csv_url: action.url
      };

    case CONTACTS_ACTIONS.CREATE_BULK_CONTACTS_SUCCESS:
    case CONTACTS_ACTIONS.DELETE_GDPR_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case CONTACTS_ACTIONS.DOWNLOAD_GDPR_DATA_SUCCESS:
      return {
        ...state,
        loading: false
      };

    case CONTACTS_ACTIONS.GET_GROUPS_SUCCESS:
    case CONTACTS_ACTIONS.CREATE_GROUP_SUCCESS:
      return {
        ...state,
        loading: false
      };

    /*case CONTACTS_ACTIONS.CREATE_CONTACT_EVENT_SUCCESS: {
      let events = get(state.events_data, [action.contact_id]) || [];
      events = events.concat(action.result);
      return {
        ...state,
        events_data: set(state.events_data, `${action.contact_id}`, events),
        loading: false
      };
    }*/
    /*case CONTACTS_ACTIONS.UPDATE_CONTACT_EVENT_SUCCESS: {
      const events = state.events_data[action.contact_id].map(e =>
        e.id == action.result.id ? action.result : e
      );
      return {
        ...state,
        events_data: set(state.events_data, `${action.contact_id}`, events),
        loading: false
      };
    }*/
    /*case CONTACTS_ACTIONS.DELETE_CONTACT_EVENT_SUCCESS: {
      const events = state.events_data[action.contact_id].filter(
        e => e.id != action.contact_event_id
      );
      return {
        ...state,
        events_data: set(state.events_data, `${action.contact_id}`, events),
        loading: false
      };
    }*/

    case BOOKING_ACTIONS.CREATE_BOOKING_SUCCESS:
    case BOOKING_ACTIONS.UPDATE_BOOKING_SUCCESS: {
      const bookingEvent = get(action.result, 'events[0]');
      if (!bookingEvent) return state;
      let found = false;
      const temp_events = (
        state.events_data[action.result.contact_id] || []
      ).map(e => {
        if (e.id === bookingEvent.id) {
          found = true;
          return bookingEvent;
        }
        return e;
      });
      const events = found ? temp_events : temp_events.concat(bookingEvent);
      return {
        ...state,
        events_data: {
          ...state.events_data,
          [action.result.contact_id]: events
        },
        loading: false
      };
    }
    case BOOKING_ACTIONS.DELETE_BOOKING_SUCCESS: {
      const updatedEvents = filter(
        get(state.events_data, [action.contact_id]),
        event => event.entity_id !== action.booking_id
      );
      return {
        ...state,
        events_data: {
          ...state.events_data,
          [action.result.contact_id]: updatedEvents
        },
        loading: false
      };
    }
    case CONTACTS_ACTIONS.GET_BATCH_CONTACTS_EVENTS_SUCCESS: {
      return {
        ...state,
        events_data: keys(action.result.events).reduce((result, contact_id) => {
          if (!result[contact_id])
            return {
              ...result,
              [contact_id]: action.result.events[contact_id]
            };
          const contact_events = action.result.events[contact_id];
          // (res, event) => {
          //   const found = res.find(e => e.id === event.id);
          //   return found ? res : res.concat(event);
          // },
          // result[contact_id]
          // );
          return {
            ...result,
            [contact_id]: contact_events
          };
        }, state.events_data),
        loading: false
      };
    }
    case CONTACTS_ACTIONS.GET_GROUPS_FAILURE:
    case CONTACTS_ACTIONS.GET_CONTACT_EVENTS_SUCCESS_FAILURE:
    case CONTACTS_ACTIONS.CREATE_CONTACT_FAILURE:
    case CONTACTS_ACTIONS.CREATE_NOTE_FAILURE:
    case CONTACTS_ACTIONS.CREATE_BULK_CONTACTS_FAILURE:
    case CONTACTS_ACTIONS.CREATE_GROUP_FAILURE:
    case CONTACTS_ACTIONS.CREATE_CONTACT_EVENT_FAILURE:
    case CONTACTS_ACTIONS.UPDATE_CONTACT_FAILURE:
    case CONTACTS_ACTIONS.UPDATE_GDPR_BASIS_FAILURE:
    case CONTACTS_ACTIONS.UPDATE_GDPR_REQUESTED_DATES_FAILURE:
    case CONTACTS_ACTIONS.ARCHIVE_CONTACT_FAILURE:
    case CONTACTS_ACTIONS.ARCHIVE_CONTACT_BATCH_FAILURE:
    case CONTACTS_ACTIONS.UNARCHIVE_CONTACT_FAILURE:
    case CONTACTS_ACTIONS.DELETE_GDPR_CONTACT_FAILURE:
    case CONTACTS_ACTIONS.DELETE_CONTACT_NOTE_FAILURE:
    case CONTACTS_ACTIONS.DELETE_CONTACT_PIN_FAILURE:
    case CONTACTS_ACTIONS.DELETE_CONTACT_DOCUMENT_FAILURE:
    case CONTACTS_ACTIONS.DELETE_CONTACT_AVAILABILITY_FAILURE:
    case CONTACTS_ACTIONS.DOWNLOAD_GDPR_DATA_FAILURE:
    case CONTACTS_ACTIONS.UPDATE_CONTACT_PIN_FAILURE:
    case CONTACTS_ACTIONS.UPDATE_CONTACT_PINS_FAILURE:
    case CONTACTS_ACTIONS.GET_BATCH_CONTACTS_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case PRODUCTIONS_ACTIONS.GET_PRODUCTION_CALENDAR_SUCCESS: {
      return {
        ...state,
        events_data: keys(action.result.events).reduce((result, contact_id) => {
          if (!result[contact_id]) {
            return {
              ...result,
              [contact_id]: action.result.events[contact_id]
            };
          }
          return {
            ...result,
            [contact_id]: action.result.events[contact_id]
          };
        }, state.events_data)
      };
    }
    default:
      return state;
  }
}
